var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"pb-8"},[_c('a',{attrs:{"href":"https://www.igpclan.it","target":"_blank"}},[_c('v-img',{attrs:{"src":require('@/assets/logo.svg'),"height":"120","contain":""}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }